import Vue from 'vue'
import Router from 'vue-router'
import Login from './../pages/Login'
import Home from './../pages/Home'
import Pengambilan from './../pages/Pengambilan'
import ValidasiDeposit from './../pages/ValidasiDeposit'
import ValidasiToga from './../pages/ValidasiToga'
import Checkin from './../pages/Checkin'
import Peserta from './../pages/Peserta'
import Sertifikat from './../pages/Sertifikat'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/pengambilan',
            name: 'Pengambilan',
            component: Pengambilan
        },
        {
            path: '/validasi-deposit',
            name: 'ValidasiDeposit',
            component: ValidasiDeposit
        },
        {
            path: '/validasi-toga',
            name: 'ValidasiToga',
            component: ValidasiToga
        },
        {
            path: '/checkin',
            name: 'Check In',
            component: Checkin
        },
        {
            path: '/peserta',
            name: 'Peserta',
            component: Peserta
        },
        {
            path: '/sertifikat',
            name: 'Sertifikat',
            component: Sertifikat
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js